<template>
  <component
    v-if="isSearchResultItem"
    :is="resultType"
    :result="result"
    :index="itemIndex"
    :defaultSiteImageUrl="defaultSiteImageUrl"
  ></component>
  <ResultInterstitialCTA :result="result" v-else />
</template>
<script lang="ts">
import ResultArticles from "./resultItems/ResultArticles.vue";
import ResultNews from "./resultItems/ResultNews.vue";
import ResultClients from "./resultItems/ResultClients.vue";
import ResultInterstitialCTA from "./resultItems/ResultInterstitialCTA.vue";

import { defineComponent, PropType } from "vue";
import {
  InterstitialCta,
  ISiteSearchResultItem,
} from "../clients/search/src/models";

export default defineComponent({
  components: {
    ResultArticles,
    ResultNews,
    ResultClients,
    ResultInterstitialCTA,
  },
  props: {
    result: {
      type: Object as PropType<ISiteSearchResultItem | InterstitialCta>,
      required: true,
    },
    resultType: {
      type: String,
      required: true,
    },
    itemIndex: {
      type: Number,
      required: false,
    },
    defaultSiteImageUrl: {
      type: String,
      required: true,
      default: ""
    }
  },
  computed: {
    isSearchResultItem() {
      return "id" in this.result && "pageTitle" in this.result;
    },
  },
});
</script>
